import { render, staticRenderFns } from "./WilliamsLogo.vue?vue&type=template&id=a42cfd8a&scoped=true"
import script from "./WilliamsLogo.vue?vue&type=script&lang=js"
export * from "./WilliamsLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42cfd8a",
  null
  
)

export default component.exports